import Vue from "vue"
import qrcode from "qrcode.vue"

Vue.component("QrCode", qrcode)
